<div [copoScroller]="{ restoreAfterViewInit: false }" #scroller="copoScroller" class="sidenav-content">
	<div *ngIf="need4steelWizardService.getState().stepIndex === 1 && !iscontactMailError">
		<copo-submission-feedback></copo-submission-feedback>
	</div>
	<copo-panel-header [isBackButtonVisible]="true" (backButtonClick)="goToBackView()" [titleHeaderText]="pageTitle">
		<ng-container *ngIf="!isLoading">
			<button  type="button" mat-button color="primary" class="n4steel-contact-email-button" (click)="openContactMailDialog()">
				<mat-icon svgIcon="mail"></mat-icon>
				<span class="n4steel-contact-email-span" translate>arcelormittal.need4steel.entry</span>
			</button>
			<button type="submit" *ngIf="isButtonNextVisible()" (click)="goNextStep()" mat-flat-button color="primary"
				class="copo-wizard-next-button">
				<span translate>arcelormittal.need4steel.action.proceed.to.order.button</span>
			</button>
			<button type="submit" *ngIf="isBtnProceedOrderVisible()" [disabled]="readOnlyUser || isConfirmDisabled" (click)="evtSubmitOrder()" mat-flat-button color="primary"
				class="copo-wizard-next-button">
				<span translate>need4steel.wizard.summary.confirm.to.order.button</span>
			</button>
		</ng-container>
		
	</copo-panel-header>
	<copo-legal-document-agreement class="font-family-summary" *ngIf="isBtnProceedOrderVisible()" [legalDocumentLabel]="n4sLabelValue" [serviceCode]="n4sServiceCode" (userAgreementCheck)="onUserAgreementCheck($event)"></copo-legal-document-agreement>
	<div class="copo-wizzard-stepper-container">
		<copo-need4steel-wizard-stepper *ngIf="getCurrentStatus()"></copo-need4steel-wizard-stepper>
		<ng-template #loading>
			<copo-loading-spinner></copo-loading-spinner>
		</ng-template>
		<router-outlet
			*ngIf="!isLoading; else loading"
			(activate)="onActivate($event)"
			(deactivate)="onDeactivate()"
			copoAfterViewInit
			(afterviewinit)="scroller.restoreState()"
		></router-outlet>
	</div>
</div>